import { IInvoice } from '../../resource/invoice/invoice.types';

import * as constants from './invoices.constants';
import * as types from './invoices.types';

export const fetchInvoices = (payload: types.IFetchInvoicesPayload = {}): types.IFetchInvoices => ({
  type: constants.FETCH_INVOICES,
  payload,
});

export const storeInvoicesList = (payload: types.IStoreInvoicesList['payload']): types.IStoreInvoicesList => ({
  type: constants.STORE_INVOICES_LIST,
  payload,
});

export const clearInvoicesPage = (): types.IClearInvoicesPage => ({
  type: constants.CLEAR_INVOICES_PAGE,
});

export const fetchInvoiceDetail = (invoiceId: IInvoice['id']): types.IFetchInvoiceDetail => ({
  type: constants.FETCH_INVOICE_DETAIL,
  payload: invoiceId,
});
